import store from '../vuex/store'
//获取滚动条当前的位置 
const getScrollTop = () => {
    var scrollTop = 0;
    if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
    }
    else if (document.body) {
        scrollTop = document.body.scrollTop;
    }
    return scrollTop;
}

//获取当前可是范围的高度 
const getClientHeight = () => {
    var clientHeight = 0;
    if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
    }
    else {
        clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
    }
    return clientHeight;
}

//获取文档完整的高度 
const getScrollHeight = () => {
    return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight); 1
}

const formatTime = date => {
    let getdata = new Date(date);
    let year = getdata.getFullYear()
    let month = getdata.getMonth() + 1
    let day = getdata.getDate()
    let hour = getdata.getHours()
    let minute = getdata.getMinutes()
    let second = getdata.getSeconds()

    return [year, month, day].map(formatNumber).join('/')
    //  + ' ' + [hour, minute, second].map(formatNumber).join(':')
}


//时间格式 yyyy-mm-dd

const timeFormat = timestamp => {
    //timestamp是整数，否则要parseInt转换,不会出现少个0的情况
    var time = new Date(timestamp);
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hours = time.getHours();
    var minutes = time.getMinutes();
    var seconds = time.getSeconds();
    return year + '-' + add0(month) + '-' + add0(date) + ' ' + add0(hours) + ':' + add0(minutes) + ':' + add0(seconds);
}
function add0(m) { return m < 10 ? '0' + m : m }

const fomateDate = date => {
    let time = new Date(date)
    let year = time.getFullYear()
    let month = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
    let dates = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
    return year + '-' + month + '-' + dates
}
// MM/DD
const fomateDateMount = date => {
    let time = new Date(date)
    let month = (time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1
    let dates = time.getDate() < 10 ? '0' + time.getDate() : time.getDate()
    return month + '/' + dates
}
const formatTimeDate = date => {
    let getdata = new Date(date);
    const year = getdata.getFullYear()
    const month = getdata.getMonth() + 1
    const day = getdata.getDate()
    const hour = getdata.getHours()
    const minute = getdata.getMinutes()
    const second = getdata.getSeconds()

    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

// 判断字符数 中文字符占2个长度
const strlen = (str) => {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        //单字节加1   
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
        }
        else {
            len += 2;
        }
    }
    return len;
}

const getTargetLenStr = (str, targetLen) => {
    let len = 0;
    for (let i = 0; i < str.length; i++) {
        let c = str.charCodeAt(i);
        //单字节加1   
        if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
            len++;
            if (len > targetLen) {
                return len - 1;
            }
        } else {
            len += 2;
            if (len > targetLen) {
                return len - 2;
            }
        }
    }
    return len;
}

// 获取文件格式
const getFileSuffix = (filename) => {
    return filename.substring(filename.lastIndexOf('.') + 1).toLowerCase();
}

//节流函数（稀释函数调用次数）
const debounce = function (func, delay = 100) {
    let timer = null
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            func.apply(this, args);
        }, delay)
    }
}

//处理图片
const handlePic = function (pictureStr) {
    if (pictureStr) {
        const imageList = pictureStr.split(",");
        let imagePicList = [];
        imageList.forEach(item => {
            imagePicList.push(item);
        });
        return imagePicList;
    }
}

//处理图片加前缀
const handlePicPlusPre = function (pictureStr) {
    if (pictureStr) {
        const imageList = pictureStr.split(",");
        let imagePicList = [];
        // 连接前缀
        imageList.forEach(item => {
            imagePicList.push(store.state.picPreUrl + item);
        });
        return imagePicList;
    }
}

//处理视频加前缀
const handleVideo = function (video) {
    if (video) {
        let videoResult = store.state.videoUrl + video;
        return videoResult;
    }
}

//处理时间轴时间格式
const timeConverter = function (time) {
    if (time) {
        time = Number(time);
        if (time > 60) {
            time = (time / 60).toFixed(1) + "h"
        } else {
            time = time + "min"
        }
        return time;
    }
}

// 判断是否手机号
const isPhoneNumber = function (phone) {
    var isChinaMobile = /^1(3[4-9]|5[012789]|8[23478]|4[478]|7[28]|9[578])\d{8}$/; //移动
    var isChinaUnion = /^1(3[0-2]|4[5]|5[56]|6[67]|7[156]|8[56]|9[6])\d{8}$/; //联通
    var isChinaTelcom = /^1(3[3])|(8[019])|(5[3])|(7[37])|(9[0139])\d{8}$/; //电信
    if(phone.length !== 11){
        return false
      }else{
        if(isChinaMobile.test(phone)){
            return true;
        }else if(isChinaUnion.test(phone)){
            return true;
        }else if(isChinaTelcom.test(phone)){
            return true;
        }else{
          return false
        }
      }
}

// 富文本图片处理
const regEditorChange = function (text) {
    let target = store.state.picPreUrl
    if(text){
        if(text.indexOf(target+'/profile')){
            return text;
        }
        text = text.replace(/\/profile/g,target+'/profile');
    } 
    console.log(text)
    return text
}

// 我们的优势数据处理
const handleData = function (number) {
    if(number){
        // let Number
       let number =  Number(number);
    }
}

// 判断当前站点是否存在
const isExistCity = function (cityList,nowsiteCityId) {
    let isExist = false;
    if(cityList&&cityList.length>0&&nowsiteCityId!=""){
        cityList.forEach((city)=>{
            if(city.cityId == nowsiteCityId){
                isExist = true;
            }
        })  
    }
    return isExist;
}

// 下载pdf文件
const pdfDownload = function (pdfUrl,title,loading=false) {
    if(loading){
        return ;
    }
    loading = true;
    if(pdfUrl){
        // let url = store.state.pdfPreUrl+pdfUrl;
        let url = pdfUrl;
        console.log(url)
        fileAjax(url, function(xhr) {
          downloadFile(xhr.response, title)
        }, {
          responseType: 'blob'
        })
        loading = true;
      }else{
        this.$modal.msgWarning("pdf链接失效，请重新生成");
      }
}

const fileAjax = function (url, callback, options) {
  let xhr = new XMLHttpRequest()
  xhr.open('get', url, true)
  if (options.responseType) {
    xhr.responseType = options.responseType
  }
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status === 200) {
      callback(xhr)
    }
 }
  xhr.send()
}
const downloadFile = function (content, filename) {
      window.URL = window.URL || window.webkitURL
      let a = document.createElement('a')
      let blob = new Blob([content],{type:'application/pdf'})
      // 通过二进制文件创建url
      let url = window.URL.createObjectURL(blob)
      console.log("downloadFile-url")
      console.log(url)
      a.href = url
      // 解决文件名带小数点的问题s
      if(filename.indexOf('.') === -1){
        a.download = filename
      }else{
        a.download = filename+".pdf"
      }      
      a.click()
      // 销毁创建的url
      window.URL.revokeObjectURL(url)
    }

  function isObject(value) {
    const valueType = typeof value
    return (value !== null) && (valueType === "object" || valueType === "function")
  }
  
  
  
  function deepClone(originValue, map = new WeakMap()) {
    // 判断是否是一个Set类型
    if (originValue instanceof Set) {
      return new Set([...originValue])
    }
  
    // 判断是否是一个Map类型
    if (originValue instanceof Map) {
      return new Map([...originValue])
    }
  
    // 判断如果是Symbol的value, 那么创建一个新的Symbol
    if (typeof originValue === "symbol") {
      return Symbol(originValue.description)
    }
  
    // 判断如果是函数类型, 那么直接使用同一个函数
    if (typeof originValue === "function") {
      return originValue
    }
  
    // 判断传入的originValue是否是一个对象类型
    if (!isObject(originValue)) {
      return originValue
    }
    if (map.has(originValue)) {
      return map.get(originValue)
    }
  
    // 判断传入的对象是数组, 还是对象
    const newObject = Array.isArray(originValue) ? []: {}
    map.set(originValue, newObject)
    for (const key in originValue) {
      newObject[key] = deepClone(originValue[key], map)
    }
  
    // 对Symbol的key进行特殊的处理
    const symbolKeys = Object.getOwnPropertySymbols(originValue)
    for (const sKey of symbolKeys) {
      // const newSKey = Symbol(sKey.description)
      newObject[sKey] = deepClone(originValue[sKey], map)
    }
    
    return newObject
  }
  
export { timeFormat, debounce, formatTime, fomateDate, fomateDateMount, formatTimeDate, getScrollTop, getClientHeight, getScrollHeight, strlen, getTargetLenStr, getFileSuffix, handlePic, handlePicPlusPre, handleVideo, timeConverter, isPhoneNumber,regEditorChange,handleData,isExistCity, pdfDownload,fileAjax,downloadFile, deepClone}


// WEBPACK FOOTER //
// ./src/util/util.js